import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SectionHeader, Empty } from "@/components/ui-bits";
import { listTattoos } from "@/lib/api";
import { formatBRL, formatDate, paymentLabel, statusLabel, statusBadge, photosOf } from "@/lib/format";

export default function Tattoos() {
  const [tattoos, setTattoos] = useState([]);

  useEffect(() => {
    listTattoos().then(setTattoos).catch(() => setTattoos([]));
  }, []);

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
      <SectionHeader
        eyebrow="Portfólio"
        title="Tatuagens"
        description="Histórico completo de tudo o que passou pela sua agulha."
      />

      {tattoos.length === 0 ? (
        <Empty title="Nenhuma tatuagem ainda" hint="Adicione tatuagens dentro do perfil de uma cliente." />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="all-tattoos">
          {tattoos.map((t) => {
            const photos = photosOf(t);
            return (
              <Link to={`/clientes/${t.client_id}`} key={t.id} className="elegant-card p-0 overflow-hidden hover:-translate-y-1 transition-all">
                {photos[0] ? (
                  <div className="relative">
                    <img src={photos[0]} alt="" className="w-full h-48 object-cover" />
                    {photos.length > 1 && (
                      <span className="absolute bottom-2 right-2 bg-black/60 text-white text-[10px] px-2 py-0.5 rounded-full">
                        +{photos.length - 1}
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="w-full h-48 bg-[#F1EEE3] flex items-center justify-center">
                    <span className="text-4xl text-[#7B8B6F]">✦</span>
                  </div>
                )}
                <div className="p-5">
                  <p className="text-xs text-[#7B8B6F] uppercase tracking-wider">{t.client_name}</p>
                  <h3 className="font-serif-display text-lg text-[#2E332C] mt-1 line-clamp-2">{t.description}</h3>
                  <div className="flex items-center justify-between mt-3">
                    <span className="text-xs text-[#5C6658]">{formatDate(t.date)}</span>
                    <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded-full border ${statusBadge(t.payment_status)}`}>{statusLabel(t.payment_status)}</span>
                  </div>
                  <div className="flex items-center justify-between mt-2">
                    <span className="font-serif-display text-xl text-[#2E332C]">{formatBRL(t.price)}</span>
                    <span className="text-xs text-[#5C6658]">{paymentLabel(t.payment_method)}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </motion.div>
  );
}
